import React from 'react';
import { Redirect } from 'react-router-dom';
import { Permissions } from '../../../shared/auth/constants/permissions';
import { useHasPermission } from '../../Session';
import BasicLayout from '../../layouts/BasicLayout';
import UsersList from '../../pages/UsersList';

const UsersRoute = () => {
    const canListUsers = useHasPermission(Permissions.USER_ACCOUNT_LIST);

    if (canListUsers) {
        return (
            <BasicLayout>
                <UsersList />
            </BasicLayout>
        );
    }

    return <Redirect to="/403" />;
};

export default UsersRoute;
